import React from 'react';
import {trpc} from '@features/utils/trpc';

export type ActiveStructureData = ReturnType<
  typeof useActiveStructure
>['activeStructure'];

export const useActiveStructure = (chatId: string | null) => {
  const {data, ...query} = trpc.screens.getActiveStructure.useQuery(
    {screenId: chatId ?? ''},
    {enabled: chatId !== null, staleTime: 60_000, refetchOnMount: false},
  );
  return {activeStructure: data, ...query};
};

export const usePrompt = () => {
  const [structureId, setStructureId] = React.useState<string | null>(null);
  const {data: previousMessage} =
    trpc.structures.getPreviousUserMessage.useQuery(
      {structureId: structureId ?? 'this-can-never-happen'},
      {enabled: structureId !== null, staleTime: 5 * 60 * 1000},
    );

  const handleSetStructureId = React.useCallback(
    (id: string) => {
      setStructureId(id);
    },
    [setStructureId],
  );

  const handleClearStructureId = React.useCallback(() => {
    setStructureId(null);
  }, [setStructureId]);

  return {
    handleSetStructureId,
    handleClearStructureId,
    previousMessage: previousMessage?.text || undefined,
  };
};
